import config from "../../assets/js/conf/config";
import { request } from '../../assets/js/utils/request';
// import {request} from '../../assets/js/utils/http';



//获取验证码
export function sendMessageData(data) {
  return request(config.baseApi + "/user/send_message", "post", data)
}

// 用户注册
export function regUserData(data) {
  return request(config.baseApi + "/user/register", "post", data)
}
//会员登录
export function loginData(data) {
  return request(config.baseApi + "/user/login", "post", data)
}


//会员登录
export function loginData2(data) {
  return request("http://localhost:3001/CreateAccount", "post", data)
}

//修改密码
export function updatePasswordData(data) {
  return request(config.baseApi + "/user/update_password", "post", data)
}

//获取会员信息
export function getUserInfoData(data) {
  return request(config.baseApi + "/user/get_user_info", "post", data)
}

//编辑用户信息
export function updateUserInfoData(data) {
  return request(config.baseApi + "/user/edit_user", "post", data)
}

//实名认证
export function updateUserIdCardData(data) {
  return request(config.baseApi + "/user/identity_auth", "post", data)
}


//获取会员头像列表
export function getUserAvatarData(data) {
  return request(config.baseApi + "/user/get_user_avatar", "post", data)
}

//设置收藏 产品收藏/取消收藏

export function setCollectionData(data) {
  return request(config.baseApi + "/goods/collection", "post", data)
}


//收藏列表
export function getCollectionData(data) {
  return request(config.baseApi + "/user/collection", "post", data)
}


//忘记密码1
export function forgotData1(data) {
  return request(config.baseApi + "/user/forgot_password_1", "post", data)
}
//忘记密码2
export function forgotData2(data) {
  return request(config.baseApi + "/user/forgot_password_2", "post", data)
}



//验证兑换码
export function setGoodsVerifyCode(data) {
  return request(config.baseApi + "/goods/code", "post", data)
}
//兑换码订单
export function setGoodsCreateOrder(data) {
  return request(config.baseApi + "/goods/order", "post", data)
}
//兑换码订单列表
export function getGoodsOrderList(data) {
  return request(config.baseApi + "/goods/convert", "post", data)
}


//我的成就
export function getAchieveData(data) {
  return request(config.baseApi + "/user/achieve", "post", data)
}
//领取成就奖励
export function setReceiveAchieveData(data) {
  return request(config.baseApi + "/user/receive_reward", "post", data)
}



// -----------------

//会员安全认证
export function safeUserData(data) {
  return request(config.baseApi + "/home/user/safe?token=" + config.token, "post", data)
}

//安全退出
export function safeOutLoginData(data) {
  return request(config.baseApi + "/home/user/safeout?token=" + config.token, "post", data)
}

